<style src="./ParkingSheet.scss" lang="scss"></style>
<template>
  <div class="parking-sheet row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="ibox-title">
          <h5>Uso dos estacionamentos</h5>
        </div>
        <div class="ibox-content">
          <table class="table table-hover no-margins">
            <thead class="header">
              <tr class="headerline">
                <th colspan="5"></th>
                <th
                  colspan="3"
                  class="collection"
                  v-if="hasPermissionToDisplay"
                >
                  Arrecadação
                </th>
              </tr>
              <tr class="headerline">
                <th>Estacionamento</th>
                <th title="Vagas Ocupadas">Ocup.</th>
                <th title="Irregularidades">Irreg.</th>
                <th title="Total de vagas ofertadas">Total</th>
                <th title="Taxa de ocupação">%</th>
                <template v-if="hasPermissionToDisplay">
                  <th class="collection">
                    {{ periods.firstPeriodStart }}h
                    <i class="fa fa-arrow-right"></i>
                    {{ periods.firstPeriodEnd }}h
                  </th>
                  <th class="collection">
                    {{ periods.secondPeriodStart }}h
                    <i class="fa fa-arrow-right"></i>
                    {{ periods.secondPeriodEnd }}h
                  </th>
                  <th class="collection">Total</th>
                </template>
              </tr>
            </thead>
            <tbody class="body">
              <tr
                class="bodyline"
                v-for="(parking, idx) in parkingUse.parkStats"
                :key="idx"
              >
                <td>
                  <small>{{ parking.parkName }}</small>
                </td>
                <td>{{ parking.count }}</td>
                <td>{{ parking.notificated }}</td>
                <td>{{ parking.spaceCount }}</td>
                <td>
                  <strong>{{ parking.occupancyRate }}</strong>
                </td>
                <template v-if="hasPermissionToDisplay">
                  <td class="collection">
                    {{ parking.firstPeriodCredits | totalToCurrencyBR }}
                  </td>
                  <td class="collection">
                    {{ parking.secondPeriodCredits | totalToCurrencyBR }}
                  </td>
                  <td class="collection total">
                    {{ parking.periodTotalCredits | totalToCurrencyBR }}
                  </td>
                </template>
              </tr>
              <tr class="bodyline total" v-if="hasPermissionToDisplay">
                <td colspan="5"></td>
                <td class="collection total">
                  {{ parkingUse.firstPeriodTotal | totalToCurrencyBR }}
                </td>
                <td class="collection total">
                  {{ parkingUse.secondPeriodTotal | totalToCurrencyBR }}
                </td>
                <td class="collection total">
                  {{ parkingUse.totalPeriods | totalToCurrencyBR }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ParkingSheet',
  props: {
    parkingUse: {
      default: {
        parkStats: [],
        firstPeriodTotal: 0,
        secondPeriodTotal: 0,
        totalPeriods: 0,
      },
    },
    periods: {
      default: () => {},
    },
  },
  filters: {
    totalToCurrencyBR(value) {
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
  },
  computed: {
    hasWalletPermission() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'dashboard-revenue-display-wallet',
        'SHOW',
      );
    },
    hasDebitPermission() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'dashboard-revenue-display-debit',
        'SHOW',
      );
    },
    hasCreditPermission() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'dashboard-revenue-display-credit',
        'SHOW',
      );
    },
    hasPermissionToDisplay() {
      return (
        this.hasWalletPermission &&
        this.hasDebitPermission &&
        this.hasCreditPermission
      );
    },
  },
};
</script>
